import { Music2, MapPin } from "lucide-react";

const PIANO_IMG = "/images/piano-class.webp";

export default function Footer() {
  return (
    <footer className="relative bg-[#1A1512] text-[#D4BAA3] overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 opacity-20">
        <img src={PIANO_IMG} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-[#D95D39] text-[#FDFBF7] flex items-center justify-center">
              <Music2 className="w-5 h-5" />
            </span>
            <span className="font-display font-bold text-2xl text-[#FFF4ED] tracking-tight">CMC-Belgique</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed">
            Conservatoire de la Musique Chrétienne — former, inspirer et faire grandir les voix et
            les musiciens au service de la louange.
          </p>
        </div>
        <div className="md:col-span-6 md:text-right">
          <p className="uppercase tracking-[0.25em] text-xs font-bold text-[#F0A202]">Masterclass Piano Gospel</p>
          <p className="mt-3 font-display text-2xl text-[#FFF4ED]">Samedi 10 octobre · 19h</p>
          <p className="mt-2 flex md:justify-end items-center gap-2 text-sm">
            <MapPin className="w-4 h-4 text-[#D95D39]" />
            81 Tollaan, 1200 Woluwe-Saint-Lambert — Bruxelles
          </p>
        </div>
      </div>
      <div className="relative border-t border-[#FFF4ED]/10">
        <p className="max-w-7xl mx-auto px-6 py-6 text-xs text-[#A08B78]">
          © {new Date().getFullYear()} CMC-Belgique — Conservatoire de la Musique Chrétienne. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
